<template>
  <CDropdown
    inNav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="pt-0"
  >
    <template #toggler>
      <CHeaderNavLink>
        <div class="c-avatar">
          <VUserIcon
            :src="currentUser.avatar"
            class="c-avatar-img "
          />
        </div>
      </CHeaderNavLink>
    </template>
    <CDropdownItem @click="toPage('/profile')">
      <CIcon name="cil-bell" /> Profile
    </CDropdownItem>
    <CDropdownItem @click="logout">
      <CIcon name="cil-task" /> Logout
    </CDropdownItem>
  </CDropdown>
</template>

<script>
import { createAuthStoreMixin, authStore } from '@/mixins/authStoreMixin'

export default {
  name: 'TheHeaderDropdownAccnt',

  mixins: [
    createAuthStoreMixin()
  ],

  computed: {
    currentUser () {
      return this[authStore.getterTypes.GETTER_USER]
    }
  },

  data () {
    return {
      itemsCount: 42
    }
  },

  methods: {
    toPage (path) {
      this.$router.push({ path })
    },
    logout () {
      this[authStore.actionTypes.ACTION_SIGN_OUT]()
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
  .c-icon {
    margin-right: 0.3rem;
  }
</style>
